import React, { useState, useEffect } from 'react';
import api from '../services/api';
import PagamentoFatura from './PagamentoFatura';

// Painel de faturas de servico (Synapse/Marketing): previa, fechadas, PDF, status e envio - Neurotech-X 04/10/2026
export default function PainelFaturasServico({ clienteId, produto }) {
    const [fechadas, setFechadas] = useState([]);
    const [sel, setSel] = useState(null);
    const [envio, setEnvio] = useState({});
    const [erro, setErro] = useState('');
    const msgErro = (e) => (e && e.response && e.response.data && e.response.data.error) || (e && e.message) || 'erro desconhecido';
    const money = (v) => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    const rotuloMes = (f) => { const t = new Date(f.referencia + 'T12:00:00Z').toLocaleDateString('pt-BR', { month: 'long', year: 'numeric', timeZone: 'UTC' }); return t.charAt(0).toUpperCase() + t.slice(1); };
    const carregar = async (manter) => {
        setErro('');
        try { const r = await api.get('/api/servicos/faturas-servico/' + clienteId + '/' + produto); const l = r.data || []; setFechadas(l); setSel(prev => (manter && l.some(x => x.id === prev)) ? prev : (l.length ? l[0].id : null)); }
        catch (e) { setFechadas([]); setSel(null); setErro('Erro ao carregar as faturas: ' + msgErro(e)); }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { if (clienteId) carregar(); }, [clienteId, produto]);
    const abrirPdf = async (url) => {
        setErro('');
        const w = window.open('', '_blank');
        try {
            const r = await api.get(url, { responseType: 'blob' });
            const u = URL.createObjectURL(r.data);
            if (w) w.location.href = u; else window.open(u, '_blank');
        } catch (e) {
            if (w) w.close();
            let m = msgErro(e);
            try { if (e.response && e.response.data instanceof Blob) { const j = JSON.parse(await e.response.data.text()); m = j.error || m; } } catch (e2) { m = m + ''; }
            setErro('Erro ao abrir a fatura: ' + m);
        }
    };
    const enviar = async (f) => {
        if (envio.id === f.id && envio.fase === 'confirmar') {
            setEnvio({ id: f.id, fase: 'enviando' });
            let falha = '';
            try { await api.post('/api/servicos/fatura-servico/' + f.id + '/enviar-whatsapp'); } catch (e) { falha = 'Falha ao enviar: ' + msgErro(e); }
            setEnvio({});
            await carregar(true);
            if (falha) setErro(falha);
        } else {
            setEnvio({ id: f.id, fase: 'confirmar' });
        }
    };
    const f = fechadas.find(x => x.id === sel) || fechadas[0];
    const status = (x) => x.wa_status === 'falhou' ? ('✗ Falhou: ' + String(x.wa_erro || '').slice(0, 80)) : (x.wa_status ? ('✓ ' + x.wa_status.charAt(0).toUpperCase() + x.wa_status.slice(1) + (x.wa_enviada_em ? ' em ' + new Date(x.wa_enviada_em).toLocaleString('pt-BR') : '')) : 'Não enviada');
    const confirmando = f && envio.id === f.id && envio.fase === 'confirmar';
    return (
        <div>
            <button type="button" className="btn-ghost" style={{ padding: '6px 12px' }} onClick={() => abrirPdf('/api/servicos/fatura/' + clienteId + '/' + produto + '/previa')}>Prévia da próxima fatura</button>
            <div style={{ marginTop: 12 }}>
                <label style={{ fontWeight: 600, fontSize: 13 }}>Faturas fechadas</label>
                {fechadas.length === 0 ? <p style={{ color: 'var(--text-muted)', fontSize: 12, marginTop: 2 }}>Nenhuma fatura emitida ainda.</p> : (
                    <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', marginTop: 6 }}>
                        <select value={sel || ''} onChange={e => setSel(e.target.value)} style={{ minWidth: 190 }}>
                            {fechadas.map(x => (<option key={x.id} value={x.id}>{rotuloMes(x) + (x.pago_em ? ' · paga' : ' · em aberto')}</option>))}
                        </select>
                        {f && (<React.Fragment>
                            <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Venc. {f.vencimento} · <b>{money(f.valor)}</b></span>
                            <button type="button" className="btn-ghost" style={{ padding: '6px 12px' }} onClick={() => abrirPdf('/api/servicos/fatura-servico/' + f.id + '/pdf')}>Abrir / Baixar PDF</button>
                            <span title={f.wa_erro || ''} style={{ fontSize: 12, fontWeight: 600, color: f.wa_status === 'falhou' ? '#c0392b' : (f.wa_status ? '#1B9AAA' : 'var(--text-muted)') }}>{status(f)}</span>
                            {envio.id === f.id && envio.fase === 'enviando'
                                ? (<span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Enviando…</span>)
                                : (<button type="button" className="btn-ghost" style={Object.assign({ padding: '6px 12px' }, confirmando ? { borderColor: '#e67e22', color: '#e67e22' } : {})} onClick={() => enviar(f)}>{confirmando ? 'Confirmar envio por WhatsApp' : 'Enviar por WhatsApp'}</button>)}
                        </React.Fragment>)}
                    </div>
                )}
                {f && (<div style={{ marginTop: 8 }}><PagamentoFatura key={f.id} tipo="servico" fatura={f} onMudou={() => carregar(true)} /></div>)}
                {erro && <p style={{ color: '#c0392b', fontSize: 12, marginTop: 6 }}>{erro}</p>}
            </div>
        </div>
    );
}
